import { lazy } from "react";
import { getDsLayoutComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const RecycleBin = lazy(() => import("@kaltura/mediaspace-features-recycle-bin"));

export const render = getDsLayoutComponentRenderer(RecycleBin);

export {
    RestoreAction,
    DeleteAction,
    BulkRestore,
    BulkDelete,
    BulkDeleteMenuItem,
    BulkRestoreMenuItem,
} from "@kaltura/mediaspace-features-recycle-bin";
